import React from "react";
import "./GuesthouseContent.css";

export default function GuesthouseContent() {
  const scrollToSection = (sectionId) => {
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      element?.scrollIntoView({ behavior: "smooth" });
    }, 100);
  };

  return (
    <div className="guesthouse-page">
      <div className="container my-5">
        <div className="guesthouse-content">
          {/* Navigation Links */}
          <div className="gh-nav-links">
            <h5>
              <button onClick={() => scrollToSection("MGHContent")} className="nav-link-btn">
                Main Guest House
              </button>
              {" | "}
            </h5>
            <h5>
              <button onClick={() => scrollToSection("GJGHContent")} className="nav-link-btn">
                Golden Jubilee Guest House
              </button>
              {" | "}
            </h5>
            <h5>
              <button onClick={() => scrollToSection("FHContent")} className="nav-link-btn">
                Faculty House
              </button>
              {" | "}
            </h5>
            <h5>
              <button onClick={() => scrollToSection("THHSContent")} className="nav-link-btn">
                PU Teachers Holiday Home, Shimla
              </button>
              {" | "}
            </h5>
            <h5>
              <button onClick={() => scrollToSection("THHDContent")} className="nav-link-btn">
                PU Teachers Holiday Home, Dalhousie
              </button>
            </h5>
          </div>

          {/* Welcome Section */}
          <div className="gh-welcome">
            <h3 className="ctitle">Welcome to Panjab University Guest House Portal</h3>
            <img className="img-responsive" src="/images/guesthouse/MGHCover2.png" alt="Guest House Cover" />
            <p>
              The primary function of Panjab University Guest Houses is to provide comfortable and
              convenient accommodation for academic stakeholders including academicians, seminar and conference attendees,
              as well as guests who visit Panjab University for official work. These guest houses also serve as
              crucial hubs for facilitating academic processes such as Ph.D. Viva Voice examinations, Selection Committee
              Meetings, Convocations, NAAC/UGC official visits, and more.
            </p>
            <p>
              The Golden Jubilee Guest House and Main Guest House at Panjab University,
              Chandigarh are equipped with state-of-the-art facilities including seminar halls and dining facilities
              to cater to the needs of these significant meetings and events.
            </p>
          </div>

          {/* Priority Table */}
          <div className="gh-section">
            <h3>Priority of Accommodation:</h3>
            <table className="gh-table" border="1">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th></th>
                  <th width="100">Priority</th>
                  <th>Description</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><strong>(A)</strong></td>
                  <td><strong>PRIORITY 1</strong></td>
                  <td>
                    For Officials visiting Chandigarh <b>for University work</b>:
                    <ol type="i">
                      <li>Fellows of the University.</li>
                      <li>University Officers of Class 'A'.</li>
                      <li>Members of various University Academic Bodies.</li>
                      <li>Principals and Professors of affiliated colleges.</li>
                      <li>Officers, Teachers, and Members of other Universities.</li>
                      <li>Officers of Govt. of India/UGC/Punjab/Haryana.</li>
                    </ol>
                  </td>
                </tr>
                <tr>
                  <td><strong>(B)</strong></td>
                  <td><strong>PRIORITY 2</strong></td>
                  <td>For Fellows/Ex-fellows of PU and officials of Panjab University <b>for personal work</b>.</td>
                </tr>
                <tr>
                  <td><strong>(C)</strong></td>
                  <td><strong>PRIORITY 3</strong></td>
                  <td>
                    For Guests of Fellows/Ex-Fellows/Officials based on their personal requests, subject to the conditions that categories at Priority 1 & 2 have not availed the facility and the booking may be liable to be cancelled in case Priority 1 and Priority 2 express the need to use the Guest Room.
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Booking Instructions */}
          <div className="gh-section">
            <h3>Booking Instructions for the Users:</h3>
            <ol className="gh-instructions">
              <li>Visit Panjab University's Guest House official website: <a href="https://pumis.puchd.ac.in" target="_blank" rel="noopener noreferrer">https://pumis.puchd.ac.in</a></li>
              <li>Register yourself on portal by providing necessary details.</li>
              <li>University Employees need to click on Registration(PU Employees).</li>
              <li>Fellows need to click on Registration(Fellow).</li>
              <li>Teachers of Affiliated Colleges need to click on Registration(Teacher Affiliated College).</li>
              <li>Your Registration is subject to verification of your credentials provided.</li>
              <li>Please ensure that all the details are properly filled and authentic documents are attached.</li>
              <li>After verification of your documents, you will receive an OTP on your registered mobile.</li>
              <li>Login with your mobile number as username and OTP as your password.</li>
              <li>Change your password after first Login.</li>
              <li>Click on booking request and complete the online booking request form ensuring all necessary details are provided.</li>
              <li>Enclose required supporting documents such as official letters of invitation or sponsorship etc.</li>
              <li>Submit your Online Booking request, get a printout of the same(from Booking Status) and send it to the Booking Office of the Guest House.</li>
            </ol>
            <p>
              Your booking request will be reviewed and availability will be checked.
              Please note that online submission of your booking request does not confirm your booking. Your booking request will be subject to the availability of the accommodation after going through the priorities.
            </p>
          </div>

          {/* Booking Extensions */}
          <div className="gh-section">
            <h3>Booking Extensions:</h3>
            <p>
              No one shall be entitled to occupy the Guest House /Golden Jubilee Guest
              House for more than 72 hours. For special reasons, however, permission may be granted
              for more than 3 days, but for not more than 10 days in any case.
            </p>
            <p>
              <strong>Check-in Time:</strong> 12:00 PM<br />
              <strong>Check-out:</strong> 11:00 AM
            </p>
            <p>
              For further query, please contact us on 0172-2534951, 9417316905 or mail us at{" "}
              <a href="mailto:guesthouse@pu.ac.in">guesthouse@pu.ac.in</a>
            </p>
          </div>

          {/* Main Guest House */}
          <div id="MGHContent" className="gh-section gh-facility">
            <h3>Main Guest House</h3>
            <div className="gh-nav-links">
              <h5>
                <button onClick={() => scrollToSection("MGHContent")} className="nav-link-btn">
                  Main Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("GJGHContent")} className="nav-link-btn">
                  Golden Jubilee Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("FHContent")} className="nav-link-btn">
                  Faculty House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHSContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Shimla
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHDContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Dalhousie
                </button>
              </h5>
            </div>
            <p>
              Located at the central point between lush greenery, adjacent to the Administrative Block and the university
              market. It is perfect for a peaceful stay in the heart of the campus.
            </p>
            <img className="img-responsive" src="/images/guesthouse/MGHCover2.png" alt="Main Guest House" />
            <p><a href="https://maps.app.goo.gl/m8BBRxuo2QJjWoZW7" target="_blank" rel="noopener noreferrer">GPS Location</a></p>

            <h4>Amenities:</h4>
            <p>
              All our guest houses provide essential beddings including bed sheets, pillows,
              pillow-covers, blankets, and mattresses. Each room is equipped with a range of amenities for your convenience.
              Guests are encouraged to inspect the room's inventory upon arrival as they will be held responsible for any
              missing or damaged items during their stay.
            </p>

            <h4>Suite Rooms</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/MGHSuite3.jpeg" alt="Suite Rooms" />
              <img src="/images/guesthouse/MGHSuite2.jpeg" alt="Suite Rooms" />
            </div>

            <h4>Rooms</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/MGHRoom2.jpeg" alt="Rooms" />
              <img src="/images/guesthouse/MGHRoom1.jpeg" alt="Rooms" />
            </div>

            <h4>Dining Hall</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/MGHDining1.jpeg" alt="Dining Hall" />
              <img src="/images/guesthouse/MGHDining2.jpeg" alt="Dining Hall" />
            </div>

            <h4>Duration Of Stay:</h4>
            <p>
              The maximum stay allowed is 3 days. Guests are required to check-in with the
              Guest-House-Keeper upon arrival. Foreign guests should provide passport and visa details at the time of check-in.
            </p>

            <h4>Tariff Charges:</h4>
            <table className="gh-table" border="1">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th>A. Rent Free Category</th>
                  <th>Rates of Room</th>
                  <th>Rates of Suite</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>PU Fellows/Former Fellows when they come to attend the University meetings.</td>
                  <td>Rent Free</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td>The Vice-Chancellor, Pro Vice-Chancellor (serving as also retired) of any University in Punjab/Haryana/Himachal Pradesh on official visit.</td>
                  <td>Rent Free</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td>
                    Members of various Universities Academic bodies/Class A Officers of Universities, Professors/Teachers, Principals (Class-1) of affiliated Colleges and Officers of Govt. of India/UGC/Punjab/Haryana on official duty (University work, VIVA VOCE, Selection Committee)
                    <br /><i>"A person invited for lecture by the University and an examiner/Speaker for University work".</i>
                  </td>
                  <td>Rent Free</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td><b>B.</b> PU Fellow/Former Fellow/Fellow's spouse/Former Fellow's spouse when they come for personal visit.</td>
                  <td>₹150/- (5% GST Extra)</td>
                  <td>₹250/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>C.</b> Members of various Universities Academic bodies/Class A Officers of Universities, Principals (Class-1) of affiliated Colleges, and Officers of Govt. of India/UGC on private visit.</td>
                  <td>₹900/- (5% GST Extra)</td>
                  <td>₹1200/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>D.</b> Persons not covered under (A) (B) and (C) above.</td>
                  <td>₹1200/- (5% GST Extra)</td>
                  <td>₹1800/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>E.</b> Persons coming for Seminar Projects & workshops.</td>
                  <td>₹1200/- (5% GST Extra)</td>
                  <td>₹1500/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>F.</b> The Vice-Chancellor, Pro Vice-Chancellor (serving as also retired) of any University in Punjab/Haryana/Himachal Pradesh on private visit.</td>
                  <td>₹1000/- (5% GST Extra)</td>
                  <td>₹1200/- (5% GST Extra)</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Golden Jubilee Guest House */}
          <div id="GJGHContent" className="gh-section gh-facility">
            <h3>Golden Jubilee Guest House</h3>
            <div className="gh-nav-links">
              <h5>
                <button onClick={() => scrollToSection("MGHContent")} className="nav-link-btn">
                  Main Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("GJGHContent")} className="nav-link-btn">
                  Golden Jubilee Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("FHContent")} className="nav-link-btn">
                  Faculty House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHSContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Shimla
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHDContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Dalhousie
                </button>
              </h5>
            </div>
            <p>Situated at a central point, adjacent to the sports department, offering easy access to recreational facilities.</p>
            <img className="img-responsive" src="/images/guesthouse/GJGH1.jpeg" alt="Golden Jubilee Guest House" />
            <p><a href="https://maps.app.goo.gl/m8BBRxuo2QJjWoZW7" target="_blank" rel="noopener noreferrer">GPS Location</a></p>

            <h4>Amenities:</h4>
            <p>
              All our guest houses provide essential beddings, including bed sheets, pillows, pillow-covers, blankets, and mattresses. Each room is equipped with a range of amenities for your convenience.
              Guests are encouraged to inspect the room's inventory upon arrival, as they will be held responsible for any missing or damaged items during their stay.
            </p>
            <p>
              This Guest House is also having a Seminar / Conference Hall, with the capacity of 140 participants that caters various VVIP programmes, Seminars, Workshops and Conferences of various departments
              of Panjab University and outside departments as well. In addition to that there is a Dining hall along-with Executive Dining Hall.
            </p>

            <h4>Rooms</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/GJGHRoom1.jpeg" alt="Room1" />
              <img src="/images/guesthouse/GJGHRoom2.jpeg" alt="Room2" />
            </div>

            <h4>Seminar-cum-Conference Hall</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/GJGHSeminar1.jpeg" alt="Seminar1" />
              <img src="/images/guesthouse/GJGHSeminar2.jpeg" alt="Seminar2" />
            </div>

            <h4>Dining Hall</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/GJGHDining1.jpeg" alt="Dining Hall1" />
              <img src="/images/guesthouse/GJGHDining2.jpeg" alt="Dining Hall2" />
            </div>

            <h4>Duration Of Stay:</h4>
            <p>
              The maximum stay allowed is 3 days. Guests are required to check-in with the Guest-House-Keeper upon arrival. Foreign guests should provide passport and visa details at the time of check-in.
            </p>

            <h4>Tariff Charges:</h4>
            <table className="gh-table" border="1">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th>A. Rent Free Category</th>
                  <th>Rates of Room</th>
                  <th>Rates of Suite</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>PU Fellows/Former Fellows when they come to attend the University meetings.</td>
                  <td>Rent Free</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td>The Vice-Chancellor, Pro Vice-Chancellor (serving as also retired) of any University in Punjab/Haryana/Himachal Pradesh on official visit.</td>
                  <td>Rent Free</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td>
                    Members of various Universities Academic bodies/Class A Officers of Universities, Professors/Teachers, Principals (Class-1) of affiliated Colleges and Officers of Govt. of India/UGC/Punjab/Haryana on official duty (University work, VIVA VOCE, Selection Committee)
                    <br /><i>"A person invited for lecture by the University and an examiner/Speaker for University work".</i>
                  </td>
                  <td>Rent Free</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td><b>B.</b> PU Fellow/Former Fellow/Fellow's spouse/Former Fellow's spouse when they come for personal visit.</td>
                  <td>₹150/- (5% GST Extra)</td>
                  <td>₹250/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>C.</b> Members of various Universities Academic bodies/Class A Officers of Universities, Principals (Class-1) of affiliated Colleges, and Officers of Govt. of India/UGC on private visit.</td>
                  <td>₹900/- (5% GST Extra)</td>
                  <td>₹1200/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>D.</b> Persons not covered under (A) (B) and (C) above.</td>
                  <td>₹1200/- (5% GST Extra)</td>
                  <td>₹1800/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>E.</b> Persons coming for Seminar Projects & workshops.</td>
                  <td>₹1200/- (5% GST Extra)</td>
                  <td>₹1500/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>F.</b> The Vice-Chancellor, Pro Vice-Chancellor (serving as also retired) of any University in Punjab/Haryana/Himachal Pradesh on private visit.</td>
                  <td>₹1000/- (5% GST Extra)</td>
                  <td>₹1200/- (5% GST Extra)</td>
                </tr>
              </tbody>
            </table>

            <h4>Tariff Charges for Seminar-cum-conference Hall and Dining Halls</h4>
            <table className="gh-table" border="1">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th>(I) GOLDEN JUBILEE CONFERENCE / SEMINAR HALL</th>
                  <th>Tariff Charges</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>For P.U. Academic Conference/Seminars.</td>
                  <td>₹5000/- (18% GST Extra)</td>
                </tr>
                <tr>
                  <td>For outsiders academic Conference/Seminars.</td>
                  <td>₹12000/- (18% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>(II) GOLDEN JUBILEE DINING HALL</b></td>
                </tr>
                <tr>
                  <td>For P.U. Academic Conference/Seminars/PU Employees/Fellows</td>
                  <td>₹3000/-(18% GST Extra)</td>
                </tr>
                <tr>
                  <td>For outsiders</td>
                  <td>₹10000/- (18% GST Extra)</td>
                </tr>
                <tr>
                  <td>For PU Employees (Retirement) under their name.</td>
                  <td>RENT FREE</td>
                </tr>
                <tr>
                  <td><b>(III) GOLDEN JUBILEE EXECUTIVE DINING HALL</b></td>
                </tr>
                <tr>
                  <td>For P.U. Academic Conference/Seminars</td>
                  <td>₹2000/- (18% GST Extra)</td>
                </tr>
                <tr>
                  <td>For outsiders</td>
                  <td>₹8000/- (18% GST Extra)</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Faculty House */}
          <div id="FHContent" className="gh-section gh-facility">
            <h3>Faculty House</h3>
            <div className="gh-nav-links">
              <h5>
                <button onClick={() => scrollToSection("MGHContent")} className="nav-link-btn">
                  Main Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("GJGHContent")} className="nav-link-btn">
                  Golden Jubilee Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("FHContent")} className="nav-link-btn">
                  Faculty House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHSContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Shimla
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHDContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Dalhousie
                </button>
              </h5>
            </div>
            <p>
              The Panjab University is having a Guest House named Faculty house especially to cater teachers of Colleges affiliated to Panjab University, Chandigarh. It situates just across the Shooting Range and within the walking distance from the Golden Jubilee Guest House, this accommodation provides convenience for your stay.
            </p>
            <img className="img-responsive" src="/images/guesthouse/FH1.jpeg" alt="Faculty House" />
            <p><a href="https://maps.app.goo.gl/dvUDF9kDCbowu7B97" target="_blank" rel="noopener noreferrer">GPS Location</a></p>

            <h4>Amenities:</h4>
            <p>
              All our guest houses provide essential beddings, including bed sheets, pillows, pillow-covers, blankets, and mattresses. Each room is equipped with a range of amenities for your convenience. Guests are encouraged to inspect the room's inventory upon arrival, as they will be held responsible for any missing or damaged items during their stay.
            </p>
            <p>
              This Guest House is also having a Seminar / Conference Hall, with the capacity of 140 participants that caters various VVIP programs, Seminars, Workshops and Conferences of various departments of Panjab University and outside departments as well. In addition to that there is a Dining hall along-with Executive Dining Hall.
            </p>

            <h4>Rooms</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/FHRoom1.jpeg" alt="Room1" />
              <img src="/images/guesthouse/FHRoom2.jpeg" alt="Room2" />
            </div>

            <h4>Duration Of Stay:</h4>
            <p>
              The maximum stay allowed is 3 days. Guests are required to check-in with the Guest-House-Keeper upon arrival. Foreign guests should provide passport and visa details at the time of check-in.
            </p>

            <h4>Tariff Charges for rooms:</h4>
            <table className="gh-table" border="1">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th>A. Rent Free Category</th>
                  <th>Rates of Room</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>PU Fellows/Former Fellows when they come to attend the University meetings.</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td>Members of various Universities Academic bodies/Class 'A' Officers of Universities, Principals (Class-1) of affiliated Colleges and Officers of Govt. of India/UGC/Punjab/Haryana on official duty (University work, Vice Voce) "A person invited for lecture by the University and an examiner/Speaker for University work".</td>
                  <td>Rent Free</td>
                </tr>
                <tr>
                  <td><b>B.</b> PU Fellow/Former Fellow/Fellow's spouse/Former Fellow's spouse when they come for personal visit.</td>
                  <td>₹150/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>C.</b> Members of various Universities Academic bodies/Class 'A' Officers of Universities, Principals (Class-1) of affiliated Colleges and Officers of Govt. of India/UGC on private visit.</td>
                  <td>₹700/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>D.</b> Teacher's from affiliated colleges on official visit (University work).</td>
                  <td>₹70/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>E.</b> Teacher's from affiliated colleges on private visit.</td>
                  <td>₹300/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>F.</b> Persons not covered under (A) to (E) above.(Private booking would be made maximum 03 days. For overstay beyond three days double the amount of the room rent shall be charged)</td>
                  <td>₹700/- (5% GST Extra)</td>
                </tr>
                <tr>
                  <td><b>G.</b> Persons coming for seminar, Projects & workshops.</td>
                  <td>₹700/- (5% GST Extra)</td>
                </tr>
              </tbody>
            </table>

            <h3>FACULTY HOUSE PRIORITY LIST:</h3>
            <ol className="gh-priority-list">
              <li><b>First Priority:</b> Reserved for teachers from the affiliated colleges of the university. Teachers from these institutions enjoy primary access to the Faculty House.</li>
              <li><b>Second Priority:</b> Subject to room availability, accommodation can also be extended to guests of university teachers, employees, and other official visitors. This flexible arrangement ensures that the Faculty House remains a valuable resource for various members of the Panjab University community and its affiliated institutions.</li>
            </ol>
          </div>

          {/* Teachers Holiday Home Shimla */}
          <div id="THHSContent" className="gh-section gh-facility">
            <h3>Panjab University Teachers Holiday Home, Shimla:</h3>
            <div className="gh-nav-links">
              <h5>
                <button onClick={() => scrollToSection("MGHContent")} className="nav-link-btn">
                  Main Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("GJGHContent")} className="nav-link-btn">
                  Golden Jubilee Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("FHContent")} className="nav-link-btn">
                  Faculty House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHSContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Shimla
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHDContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Dalhousie
                </button>
              </h5>
            </div>
            <p>
              The Panjab University is having a Guest House named Teachers Holiday Home, Shimla to provide accommodation to the teachers of Panjab University Departments, Employees of PU and Teachers of Colleges affiliated to Panjab University, Chandigarh. It situates just below the Victory Tunnel Road, Shimla. This accommodation provides convenience for your stay.
            </p>
            <div className="gh-images">
              <img src="/images/guesthouse/THHS1.jpeg" alt="THHS House1" />
              <img src="/images/guesthouse/THHS2.jpeg" alt="THHS House2" />
            </div>

            <h4>Amenities:</h4>
            <p>
              All our guest houses provide essential beddings, including bed sheets, pillows, pillow-covers, blankets, and mattresses. Each room is equipped with a range of amenities for your convenience. Guests are encouraged to inspect the room's inventory upon arrival, as they will be held responsible for any missing or damaged items during their stay.
            </p>

            <h4>Rooms</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/THHSRoom1.jpeg" alt="Room1" />
              <img src="/images/guesthouse/THHSRoom2.jpeg" alt="Room2" />
            </div>

            <h4>For the Booking</h4>
            <p>Please download the booking form and submit the same after filling it.</p>
            <a href="/images/guesthouse/shimla-guest-house-form.pdf" download className="btn btn-primary btn-sm">
              Download Form for Shimla & Dalhousie
            </a>

            <h4>Duration Of Stay:</h4>
            <p>
              The maximum stay allowed is 3 days. Guests are required to check-in with the Guest-House-Keeper upon arrival. Foreign guests should provide passport and visa details at the time of check-in.
            </p>

            <h4>Tariff Charges for rooms:</h4>
            <table className="gh-table" border="1">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th>Rent Category</th>
                  <th>Rates of Room</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>A.</b> PU Fellows/Former Fellows/PU Examiners (Max two rooms for self and accompanying dependents)</td>
                  <td>₹200/-</td>
                </tr>
                <tr>
                  <td><b>B.</b> Employees of Panjab University and its affiliated Colleges (Max two rooms for self and accompanying dependents)</td>
                  <td>₹400/-</td>
                </tr>
                <tr>
                  <td><b>C.</b> Retired employees of Panjab University & its affiliated colleges (Max two rooms for self and accompanying dependents)</td>
                  <td>₹500/-</td>
                </tr>
                <tr>
                  <td><b>D.</b> Persons not covered under A to B above.</td>
                  <td>₹1200/-</td>
                </tr>
              </tbody>
            </table>
          </div>

          {/* Teachers Holiday Home Dalhousie */}
          <div id="THHDContent" className="gh-section gh-facility">
            <h3>Panjab University Teachers Holiday Home, Dalhousie:</h3>
            <div className="gh-nav-links">
              <h5>
                <button onClick={() => scrollToSection("MGHContent")} className="nav-link-btn">
                  Main Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("GJGHContent")} className="nav-link-btn">
                  Golden Jubilee Guest House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("FHContent")} className="nav-link-btn">
                  Faculty House
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHSContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Shimla
                </button>
                {" | "}
              </h5>
              <h5>
                <button onClick={() => scrollToSection("THHDContent")} className="nav-link-btn">
                  PU Teachers Holiday Home, Dalhousie
                </button>
              </h5>
            </div>
            <p>
              The Panjab University is having a Guest House named Teachers Holiday Home, Dalhousie to provide accommodation to the teachers of Panjab University Departments, Employees of PU and Teachers of Colleges affiliated to Panjab University, Chandigarh. This accommodation provides convenience for your stay.
            </p>
            <div className="gh-images">
              <img src="/images/guesthouse/THHD1.jpeg" alt="THHD House1" />
              <img src="/images/guesthouse/THHD2.jpeg" alt="THHD House2" />
            </div>

            <h4>Amenities:</h4>
            <p>
              All our guest houses provide essential beddings, including bed sheets, pillows, pillow-covers, blankets, and mattresses. Each room is equipped with a range of amenities for your convenience. Guests are encouraged to inspect the room's inventory upon arrival, as they will be held responsible for any missing or damaged items during their stay.
            </p>

            <h4>Rooms</h4>
            <div className="gh-images">
              <img src="/images/guesthouse/THHDRoom1.jpeg" alt="Room1" />
              <img src="/images/guesthouse/THHDRoom2.jpeg" alt="Room2" />
            </div>

            <h4>Duration Of Stay:</h4>
            <p>
              The maximum stay allowed is 3 days. Guests are required to check-in with the Guest-House-Keeper upon arrival. Foreign guests should provide passport and visa details at the time of check-in.
            </p>

            <h4>Tariff Charges for rooms:</h4>
            <table className="gh-table" border="1">
              <thead style={{ '--bs-table-bg': '#008080', color: 'white' }}>
                <tr>
                  <th>Rent Category</th>
                  <th>Rates of Room</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td><b>A.</b> PU Fellows/Former Fellows/PU Examiners (Max two rooms for self and accompanying dependents)</td>
                  <td>₹200/-</td>
                </tr>
                <tr>
                  <td><b>B.</b> Employees of Panjab University and its affiliated Colleges (Max two rooms for self and accompanying dependents)</td>
                  <td>₹400/-</td>
                </tr>
                <tr>
                  <td><b>C.</b> Retired employees of Panjab University & its affiliated colleges (Max two rooms for self and accompanying dependents)</td>
                  <td>₹500/-</td>
                </tr>
                <tr>
                  <td><b>D.</b> Persons not covered under A to B above.</td>
                  <td>₹1200/-</td>
                </tr>
              </tbody>
            </table>

            <h4>For the Booking</h4>
            <p>Please download the booking form and submit the same after filling it.</p>
            <a href="/images/guesthouse/shimla-guest-house-form.pdf" download className="btn btn-primary btn-sm">
              Download Form for Shimla & Dalhousie
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
